import { useEffect, useRef } from "react";

import { useGlobal } from "../../contexts/globalContext";

export const Loading = () => {
  const { MEETING_STATE } = useGlobal();
  const loadingRef = useRef();

  useEffect(() => {
    loadingRef.current.style.top = `-${document.getElementsByClassName("navbar-menu")[0].offsetHeight}px`;
  }, []);

  return (
    <div ref={loadingRef} className="loading">
      <p>Loading...</p>
      {MEETING_STATE.consentDialog && <p>Give permission to camera and microphone.</p>}
    </div>
  );
};
